import styled from 'styled-components';

const StyledAppContentWrapper = styled.div`
    width: 100%;
`;

export default StyledAppContentWrapper;
